export default "__VITE_ASSET__Dh3o2GIX__"